<template>
    <div class="dialog" v-show="show">
        <div class="mask"></div>
        <div class="dialog-container" :style="{'width':width}">
            <div class="icon-close" @click="closeDailog">
                <svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5370"><path d="M512 466.752l265.386667-265.386667a32 32 0 0 1 45.226666 45.269334L557.269333 512l265.386667 265.386667a32 32 0 0 1-45.269333 45.226666L512 557.269333l-265.386667 265.386667a32 32 0 0 1-45.226666-45.269333L466.730667 512 201.365333 246.613333a32 32 0 0 1 45.269334-45.226666L512 466.730667z"  p-id="5371"></path></svg>
            </div>
            <div class="dialog-head">
                <h3 class="dialog-title" :class="{'center':titleCenter}">{{title}}</h3>
            </div>
            <div class="dialog-body">
                <slot />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'gkDialog',
    props:{
        show:{
            type:Boolean,
            default:false,
        },
        title:{
            type:String,
            default:'标题',
        },
        width:{
            type:String,
            default:'700px',
        },
        titleCenter:{
            type:Boolean,
            default:false,
        },
    },
    data(){
        return{
            
        }
    },
    methods: {
        closeDailog(){
            this.$emit('close',this.show);
        }
    },
}
</script>
<style lang="scss">
.dialog{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    .mask{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 98;
        background-color: rgba(0,0,0,0.4);
    }
    .dialog-container{
        position: fixed;
        left: 50%;
        top: 50%;
        width: 700px;
        max-height: 100%;
        transform: translate(-50%,-50%);
        z-index: 99;
        padding-top: 48px;
        overflow: hidden;
        // overflow-y: auto;
    }
    .dialog-head{
        width: 100%;
        height: 48px;
        background-color: #f75959;
        padding: 12px 20px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
    }
    .dialog-title{
        line-height: 24px;
        color: #fff;
        font-size: 18px;
        font-weight: normal;
        &.center{
            text-align: center;
        }
    }
    .icon-close{
        position: absolute;
        right: 0px;
        top: 4px;
        z-index: 3;
        width: 40px;
        height: 40px;
        line-height: 36px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        cursor: pointer;
    }
    .dialog-body{
        background-color: #fff;
        padding: 10px 20px 30px;
    }
}
</style>